<template>
<div id="aduanas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
    <!-- <p/> -->
     <!-- <v-alert border="top"
      colored-border
      type="error"
      elevation="2"><p/>
            <center>
                <h1>Aviso</h1>
                    <h3>
            Apreciables usuarios, hacemos de su conocimiento que el Sistema de Operación Integral Aduanero, 
            presenta problemas de desempeño por ajustes de servicio en la consulta remota.  </h3><p/>
            <h2>Agradecemos su comprensión.</h2>  <p/>
             <h3> Hemos reportado los errores presentados con el área correspondiente y estamos en monitoreo 
            de cambios para habilitar nuevamente el servicio de consulta
            </h3>
            </center>
    </v-alert> -->

 
           
                <base-material-card  color="primary" icon="library_books" title="Consulta Directa" class="elevation-1 px-5 py-3" >
                <!-- <br/> -->
                    <!-- <v-tabs grow style="margin-bottom: 30px;" >
                            <v-tabs-slider color="primary" ></v-tabs-slider> -->

                    <!--         <v-tab key="consulta" >
                                <v-card-title><b>Consulta de Directa</b></v-card-title>
                            </v-tab> -->
                            <!-- <v-tab key="sat" >
                                <v-card-title><b>Detalle de Cruce o Módulo del Despacho</b></v-card-title>
                            </v-tab> -->
                            <!-- <v-tab-item key="consulta" style="margin: 30px;" > -->
                             
                    <v-card-text fill-height>
                        <v-row>
                            <v-col sm="3" md="3" lg="3" align-center justify-center>   
                                <br><br>                             
                                <v-text-field v-model="pedimento"  label="Número de Pedimento" @input="generateQrCode" />
                                <v-text-field v-model="ap" size="20px" label="Año" @input="generateQrCode" />
                            </v-col>
                            <v-col sm="4" md="4" lg="4">
                                <div v-if="ap>0">
                                    <a :href="qrText" target="_blank" >
                                        <v-img v-if="qrSrc" :src="qrSrc" aspect-ratio="2" width="200px" height="200px" ></v-img></a>
                                    <br/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<v-btn color="green" small @click="link1" >
                                            <v-icon>mdi-window</v-icon> Abrir Enlace VUCEM
                                        </v-btn>
                                
                                </div>
                            </v-col>
                            <v-col sm="5" md="5" lg="5">
                                <img src="/static/SOIA_AVISO.png"></img>
                            </v-col>
                        </v-row>
                                               
                         <!-- <div class="iframe-container" v-if="ap>0" >
                                <iframe  id="myIframe" :src="qrText" allowfullscreen></iframe>
                        </div> -->
                    </v-card-text>
                     <!-- </v-tab-item>
                            <v-tab-item key="sat" style="margin: 30px;" > -->
                         <!--        <v-card-text>
                                     <br/>
                                    <v-btn color="green" small @click="link2" >
                                            <v-icon>mdi-windows</v-icon> Abrir Enlace VUCEM
                                        </v-btn>
                                    
                                 <div class="iframe-container" >
                                            <iframe  id="myIframe2" src="https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarapd_cep.aspx" allowfullscreen></iframe>
                                            
                                    </div> 
                                </v-card-text> -->
             <!--                </v-tab-item>     
                     </v-tabs>     -->
                  
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import qrCode from 'qrcode';

export default {

    data: () => ({
        ad: "",
        pa: "",
        np: "",
        ap: "",
        pedimento:"",
        qrSrc: null,
        aduanas: [],
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Vucem-Pedimento",
                disabled: true,
                to: ""
            },
            {
                text: "Consulta Directa",
                disabled: true,
                to: ""
            }
        ],

        title: "",

    }),
    computed: {
        qrText() {
          //  return 'https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarapd_cep.aspx?pa=' + this.pa + '&dn=' + this.np + '&s=0&ap=' + this.ap + '&pad=' + this.ad + '&ad=' ;
            return ' https://aplicacionesc.mat.sat.gob.mx/SOIA_CR_WEB/oia_consultarapd_cep.aspx?pa=' + this.pa + '&dn=' + this.np + '&s=0&ap=' + this.ap + '&pad=' + this.ad + '&ad=' ;
           
        }

    },

    methods: {
        reload(){
            var myIFrame = document.getElementById("myIframe");
            myIFrame.src = "";
            myIFrame.src = this.qrText;
            var frameDocument = myIFrame.contentDocument ? myIFrame.contentDocument : myIFrame.contentWindow.document;
           
        },
      reload2(){
            var myIFrame = document.getElementById("myIframe2");
            myIFrame.src = "";
            myIFrame.src = "https://aplicacionesc.mat.sat.gob.mx/SOIA_CR_WEB/oia_consultarapd_cep.aspx";

            var frameDocument = myIFrame.contentDocument ? myIFrame.contentDocument : myIFrame.contentWindow.document;
           
        },
      link1: function () {   

          window.open(this.qrText, "_blank");    

      },
       link2: function () {   

          window.open("https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarapd_cep.aspx", "_blank");    

      },
        createObjectUrl(err, canvas) {
            if (!err) {
                canvas.toBlob((blob) => {
                    this.qrSrc = window.URL.createObjectURL(blob)
                })
            } else {
                console.warn('generateQrCode:ERROR', err)
            }
        },
        generateQrCode() {
            var a = this.pedimento.split("-");        
            this.ad = a[0];
            this.pa = a[1];
            this.np = a[2];
            window.URL.revokeObjectURL(this.qrSrc)
            qrCode.toCanvas(this.qrText, {}, this.createObjectUrl)
        },

        cargar: function () {
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.aduanas.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                   console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/aduanas/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.generateQrCode();
    }
};
</script>


<style scoped>
.iframe-container {
  
  padding-top: 56.25%;
  position: relative;
  overflow: hidden;
}
 
.iframe-container iframe {
   border: 0;
   height: 100%;
   left: 0;
   position: absolute;
   top: 0;
   width: 100%;
}
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>